export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Pharmaceutical production operators and technicians, shift and area supervisors, QA and QC staff, validation and engineering technicians, maintenance staff in pharmaceutical plants, people entering the pharmaceutical industry and advanced students of pharmacy, chemical engineering and biotechnology.',
  ],
  ['Content depth?', 'From fundamentals to professional-level manufacturing, quality systems, contamination control, sterile processing and validation.'],
  [
    'What exactly do I get?',
    'A technical reference collection in PDF format. It is not software, editable templates, SOPs to copy or a course with a certificate, and it does not certify anyone.',
  ],
  [
    'Does it replace my site procedures?',
    "No. It does not replace your site's approved procedures (SOPs), batch records, quality unit decisions, regulatory requirements or the judgment of qualified personnel. Always follow them.",
  ],
  [
    'International?',
    'Yes. Based on internationally used GMP concepts and terminology; always follow your site procedures and applicable regulations.',
  ],
  ['Format?', 'Professional PDF files with instant access.'],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
